import React from 'react';
import './index.less';
import { InfoCircleOutlined } from '@ant-design/icons';
import IconTip from '@/components/icon-tip';

const ModuleTitle = (props) => {
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginTop: '18px' }}>
        {/* <div className="module-title-icon" /> */}
        <div>
          <span className="module-title-text">{props.title}</span>
          {props.hovertext && <IconTip title={props.hovertext} type="question" size="small" />}
        </div>

        {props.desc && (
          <>
            <InfoCircleOutlined style={{ marginLeft: '14px', color: '#FEB00E' }} width={12} height={12} />
            <span style={{ fontSize: '12px', color: 'rgba(0, 0, 0, 0.45)', marginLeft: '3px', lineHeight: '22px' }}>
              {props.desc}
            </span>
          </>
        )}
      </div>
      {props.children}
    </div>
  );
};
export default ModuleTitle;
